import api from './client';

export const productsApi = {
  getAll: (params = {}) => api.get('/products', { params }),
  getPopular: (limit = 12) => api.get(`/products/popular?limit=${limit}`),
  getOne: (id) => api.get(`/products/${id}`),
};
